import { getConfig } from '../config/configuration';
import type { HpDispatchFunction } from './actionTypes';
import { fetchResolver } from './fetchResolver';
import { ErrorMap } from 'interfaces/errorTypes';
import { analyticsUserType, GTM_EVENT_TYPES, sendAnalytics } from 'analytics';
import { FullPolicyData } from 'interfaces/customerDataTypes';
import { AUDIT_TYPE } from 'interfaces/auditTypes';
import { sendAuditEvent } from 'utils';
import { CustomerInsuranceSummaryResponse } from './getCustomerInsuranceSummaryAction';
interface ToggleAutoRenewalStatusProps {
  selectedPolicy: FullPolicyData;
  isAutoRenewal: boolean;
  username: string;
  isAgent: boolean;
}

export function toggleAutoRenewalStatusAction({
  selectedPolicy,
  isAutoRenewal,
  username,
  isAgent
}: ToggleAutoRenewalStatusProps) {
  return (dispatch: HpDispatchFunction<ErrorMap | CustomerInsuranceSummaryResponse>): Promise<void> | undefined => {
    dispatch({ type: 'TOGGLE_AUTO_RENEW_LOADING' });
    const {
      policyDetailsId,
      historyId,
      email,
      title,
      forename,
      surname,
      policyInceptionDate,
      policyEndDate,
      phoneNumber,
      altPhoneNumber,
      riskPostcode,
      riskAddress,
      policyNumber,
      insuredPartyId
    } = selectedPolicy;

    const data = {
      policyDetailsId,
      historyId,
      emailAddress: email,
      title,
      forename,
      surname,
      effectiveDate: policyInceptionDate,
      endDate: policyEndDate,
      phoneNumber,
      altPhoneNumber,
      riskPostCode: riskPostcode,
      riskAddress,
      policyNumber,
      isAutoRenewal,
      insuredPartyId,
      ...(isAgent && { agentUsername: username })
    };

    const { websiteEndpoint } = getConfig();
    const url = `${websiteEndpoint}/api/customer/policy/toggle-auto-renewal`;

    return fetchResolver<any>({
      options: { url, data, method: 'POST', description: `Toggle auto-renewal status` },
      dispatch,
      successAction: (response) => {
        const auditEventType = isAutoRenewal
          ? AUDIT_TYPE.TOGGLE_AUTO_RENEWAL_ON_SUCCESS
          : AUDIT_TYPE.TOGGLE_AUTO_RENEWAL_OFF_SUCCESS;
        sendAuditEvent({ activityId: auditEventType, policyDetailsId, historyId, policyNumber });
        sendAnalytics({
          event: GTM_EVENT_TYPES.AUTO_RENEW,
          detail: { is_auto_renewal: isAutoRenewal, usertype: analyticsUserType(isAgent) }
        });
        dispatch({ type: 'TOGGLE_AUTO_RENEW_SUCCESS', payload: response });
      },
      failedAction: (err) => {
        const auditEventType = isAutoRenewal
          ? AUDIT_TYPE.TOGGLE_AUTO_RENEWAL_ON_FAILURE
          : AUDIT_TYPE.TOGGLE_AUTO_RENEWAL_OFF_FAILURE;
        sendAuditEvent({ activityId: auditEventType, policyDetailsId, historyId, policyNumber });
        dispatch({ type: 'TOGGLE_AUTO_RENEW_ERROR', payload: err.message });
      }
    });
  };
}
